import React from 'react';
import styled from 'styled-components';

import { Theme } from '../Theme';
import { CircularProgress as MUICircularProgress } from '@mui/material';

const CircularProgressContainer = styled.div`
	display: flex;
	flex: 1;
	min-height: auto;
	min-width: ${(props) => (props.width ? props.width : 'auto')};
	margin: 0 auto;
	padding: 0.5rem 0;
	justify-content: center;
	overflow: hidden;
`;

export const CircularProgress = ({ showSpinner = false, size = 40, width = 'auto', color = 'secondary', ...props }) => {
	return (
		<CircularProgressContainer width={width}>
			<MUICircularProgress
				style={{
					display: `${showSpinner ? 'block' : 'none'}`,
					alignSelf: 'center',
				}}
				size={size}
				color={color}
			/>
		</CircularProgressContainer>
	);
};
